import { useLayoutEffect, useEffect } from "react";
const useIsomorphicLayoutEffect = (
  // @ts-ignore
  typeof window !== "undefined" ? useLayoutEffect : useEffect
);
export {
  useIsomorphicLayoutEffect
};
//# sourceMappingURL=useIsomorphicLayoutEffect.js.map
